import { Grid, Switch } from '@mui/material'
import { useIntl } from 'react-intl'

import { SettingsControlSection } from '../SettingsComponent/SettingsComponent'

export default function SettingsNotifications(props) {
  const intl = useIntl()
  const { companyState, setCompanyState } = props

  const handleChange = (id: string, value: boolean) => {
    setCompanyState({
      ...companyState,
      notifications_configs: {
        ...(companyState.notifications_configs || {}),
        [id]: value
      }
    })
  }

  return (
    <Grid container>
      <Grid item xs={12} data-cy='employees_can_receive_email_notifications'>
        <SettingsControlSection
          {...props}
          id='employees_can_receive_email_notifications'
          label={intl.formatMessage({
            id: 'settings.sectionControlLabels.notifications.enableEmailNotifications',
          })}
          ControlComponent={Switch}
          value={companyState.notifications_configs?.employees_can_receive_email_notifications ?? false}
          onChange={(e) => handleChange('employees_can_receive_email_notifications', e.target.checked)}
        />
      </Grid>
      <Grid item xs={12} data-cy='employees_can_receive_sms_notifications'>
        <SettingsControlSection
          {...props}
          id='employees_can_receive_sms_notifications'
          label={intl.formatMessage({
            id: 'settings.sectionControlLabels.notifications.enableSmsNotifications',
          })}
          ControlComponent={Switch}
          value={companyState.notifications_configs?.employees_can_receive_sms_notifications ?? false}
          onChange={(e) => handleChange('employees_can_receive_sms_notifications', e.target.checked)}
        />
      </Grid>
    </Grid>
  )
}
